import {
  useMutation,
  useQueryClient,
  type QueryKey,
} from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { invalidateQueryKeys } from './invalidateQueryKeys'

interface SweepstakeWinnersMessageData {
  sweepstakeWinnerIds: number[]
}

interface UsePostLocationSweepstakeWinnerMessageProps {
  onSuccess?: () => void
  onError?: () => void
  invalidateQueryKeys?: readonly QueryKey[]
}

export const usePostLocationSweepstakeWinnerMessage = ({
  onSuccess,
  onError,
  invalidateQueryKeys: queryKeysToInvalidate,
}: UsePostLocationSweepstakeWinnerMessageProps) => {
  const queryClient = useQueryClient()

  const postSweepstakeWinnerMessage = useTypedApiClient({
    path: '/admin/sweepstake-winners/locationSweepstakes/message',
    method: 'post',
  })

  return useMutation({
    mutationFn: async (request: SweepstakeWinnersMessageData) => {
      const { data } = await postSweepstakeWinnerMessage(request)
      return data
    },
    onSuccess: async () => {
      if (
        queryKeysToInvalidate !== undefined &&
        queryKeysToInvalidate.length > 0
      ) {
        await invalidateQueryKeys(queryClient, queryKeysToInvalidate)
      } else {
        await queryClient.invalidateQueries({
          queryKey: ['/sweepstakes'],
        })
        await queryClient.invalidateQueries({
          queryKey: ['/sweepstakes/drawing-info/multi-draw'],
        })
      }

      onSuccess?.()
    },
    onError,
  })
}
